import isRequired from './isRequired';
import getValidator from './getValidator';

const isRequiredIfAll = (config) => (value) => {
  const validator = getValidator(config.validator);
  const { values } = config;
  if (values.every((v) => validator(config)(v) === null)) {
    return isRequired(config)(value);
  }
  return null;
};

export default isRequiredIfAll;
